class customSelect extends HTMLElement{
    constructor() {
      super();
      this.selectContainer = this.querySelector('.custom--select');
      this.select = this.querySelector('ul');
      this.initOption = this.querySelector('.default');
      this.options = this?.select?.querySelectorAll('li');
  
      this.options?.forEach(option => option.addEventListener('click', this.toggleOptions.bind(this)));
      this.initOption?.addEventListener('click', this.manageVisibility.bind(this));
  
      this.addEventListener('click', (event) => {
        if (!event.target.closest('[data-province-selector]')) {
          provinceSelectorDropdown?.classList.add('d-none');
        }
        event.stopPropagation();
      });
      document.body.addEventListener('click', (event)=> {
        if (document.querySelector('.overlay--body')) {
          if (!event.target.closest('[data-province-selector]')) {
            provinceSelectorDropdown?.classList.add('d-none');
          }
          return;
        }
        if (!event.target.closest('[data-province-selector]')) {
          Utility.toggleElement(this.selectContainer, 'close')
        }
      });
    }
  
    /**
     * Toggle custom select option
     * @param event  
     */
    toggleOptions(event){
      let _this = event.currentTarget;
      this.options.forEach(option => option.classList.remove('selected'));
      _this.classList.add('selected');
      if (this.initOption.querySelector('.option_txt')) {
        this.initOption.querySelector('.option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
      }
      if (!this?.classList.contains('state-dropdown')) {
        Utility.toggleElement(this.selectContainer, 'close');
      }
    }
  
    /**
     * Hide/Show of custom select option
     * @param event 
     */
    manageVisibility(event){
      let isOpen = this.selectContainer.classList.contains('open');
      if (isOpen) {
        Utility.toggleElement(this.selectContainer, 'close');
        if (this.classList.contains('custom-dropdown')) {
          this.classList.remove('open');
          this.classList.remove('sort-active');
        }
      }else{
        if (document.querySelector('[data-select-state-note].open')) {
          Utility.toggleElement(document.querySelector('.state-dropdown .custom--select[data-select-state-note]'), 'close');
        }

        Utility.toggleElement(this.selectContainer, 'open');

        if (this.classList.contains('custom-dropdown')) {
          this.classList.add('open');
          this.classList.add('sort-active');
          if (document.querySelector('body').classList.contains('Mega_menu')) {
            document.querySelectorAll(".megamenu").forEach(element => {
              if (element.classList.contains('open')) {
                element.classList.remove('open');
              }
            })
            document.querySelector('site-overlay').classList.remove('overlay--body');
            document.querySelector('body').classList.remove('Mega_menu', 'scroll-fixed');
          }
        }

        if (this.classList.contains('state-dropdown')) {
          let currentState = localStorage.getItem('user_location');
          let full_state_name = document.querySelector(`.city [data-country-code="${currentState}"]`)?.innerText;
          if (full_state_name && document.querySelector('[data-province-selector]')) {
            document.querySelector('[data-province-selector]').value = full_state_name;
          }
        }
      }
    }
  }
  customElements.define('custom-select', customSelect);